import { useEffect, useState } from 'react';
import { QueryClientProvider } from '@tanstack/react-query';
import Layout from './components/layout/Layout.jsx';
import { defaultRouteKey, getHashForKey, navRoutes, parseHash, routeMap } from './config/routes.jsx';
import { queryClient } from './queryClient';
import { SessionProvider } from './providers/SessionProvider.jsx';
import { IdleProvider } from './providers/IdleProvider.jsx';

// There are no styles specific to this component - to add styles, create and import App.css

export default function App() {
  const [activeRouteKey, setActiveRouteKey] = useState(() => parseHash(window.location.hash).key);

  useEffect(() => {
    const syncRouteFromHash = () => {
      const route = parseHash(window.location.hash);
      setActiveRouteKey(route.key);
      const normalizedHash = getHashForKey(route.key);
      if (window.location.hash !== normalizedHash) {
        window.location.hash = normalizedHash;
      }
    };

    syncRouteFromHash();
    window.addEventListener('hashchange', syncRouteFromHash);
    return () => window.removeEventListener('hashchange', syncRouteFromHash);
  }, []);

  // TODO: Navigation should be handled by <a> elements with hrefs to enable right-clicking, opening in new tabs, general a11y, etc.
  const navigateTo = key => {
    const targetRoute = routeMap[key] || routeMap[defaultRouteKey];
    if (!targetRoute) return;
    setActiveRouteKey(targetRoute.key);
    if (window.location.hash !== targetRoute.hash) {
      window.location.hash = targetRoute.hash;
    }
  };

  const currentRoute = routeMap[activeRouteKey] || routeMap[defaultRouteKey];
  const ActiveComponent = currentRoute.component;

  return (
    <QueryClientProvider client={queryClient}>
      <SessionProvider>
        <IdleProvider>
          <Layout currentRoute={currentRoute} navRoutes={navRoutes} onNavigate={navigateTo}>
            <ActiveComponent />
          </Layout>
        </IdleProvider>
      </SessionProvider>
    </QueryClientProvider>
  );
}
